export const USER_URL = '/user';

export const CATEGORY_URL = '/category';

export const TOKEN_URL = '/token';
